'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global initialize*/
/*global services*/
function BasketPreview(containerId) {
    this.containerId = containerId;
    this.$container = null;
    this.$containerContent = null;

    this.init();
}

BasketPreview.prototype = $.extend({}, {
    construtor: 'BasketPreview',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.off('click', '.remove-basket-item');
        _this.$container.on('click', '.remove-basket-item', function removeBasketClickClb() {
            var $basketItemWrapper = $(this).closest('.basket-item-wrapper');
            blockElement($basketItemWrapper);
            _this.removeBasketItems($(this).attr('href'), function () {
                unBlockElement($basketItemWrapper);

                if (services.has('catalogFilterBasketItems')) {
                    services.get('catalogFilterBasketItems').loadCatalogFilterBasketItems();
                }
            });

            return false;
        });

        return _this;
    },

    //**************************************************************************

    removeBasketItems: function removeBasketItems(url, callBack) {
        var _this = this;

        $.getCORS(url, function (res) {
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.loadBasketPreview();
                    if(services.get('catalogFilter')) {
                        services.get('catalogFilter').doItemsSearch();
                    }

                    if(callBack) {
                        callBack();
                    }

                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    loadBasketPreview: function loadBasketPreview() {
        var _this = this;

        blockElement(_this.$container);
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=basket&method=js_get_basket_preview', function (res) {
            unBlockElement(_this.$container);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$container.html(res.data.html);
                    initialize(_this.$container);
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerId);
        _this.registerCallbacks();

        //_this.loadBasketPreview();

        return _this;
    }
});
